var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { Box, useRecipe } from "@chakra-ui/react";
import { ResponsiveImage } from "@/components/cortex";
import { CompanyAvatar } from "./CompanyAvatar";
export var SearchResultsCompanyLogo = function (_a) {
    var job = _a.job, variant = _a.variant;
    var recipe = useRecipe({ key: "SearchResultsCompanyLogo" });
    var styles = recipe({ variant: variant });
    return (_jsx(Box, __assign({ css: styles }, { children: job.companyLogo === undefined ? (_jsx(CompanyAvatar, { companyName: job.company })) : (_jsx(ResponsiveImage, { src: job.companyLogo, alt: "", htmlHeight: "100%", htmlWidth: "100%", css: { borderRadius: styles.borderRadius } })) })));
};
